import clsx from "clsx";
import { Button, Icon } from "@/shared/ui";

type Props = {
  onChange: () => void;
  is?: boolean;
};

export default function CreateEntitySetLocation({ is, onChange }: Props) {
  return (
    <div className="flex items-center gap-1.5 h-[2.625rem]">
      <div
        className={clsx(
          "h-full grow flex items-center justify-between rounded-[0.5rem] bg-gradient-to-r",
          "text-14 font-medium px-4",
          is
            ? "from-[#21652C]/20 to-[#21652C]/5 text-[#84FF97]"
            : "from-[#D73434]/20 to-[#D73434]/5 text-[#FF4E4E]",
        )}
      >
        {is ? "Установлено" : "Не установлено"}
        <Icon name={is ? "checked" : "close"} className="w-3" />
      </div>
      <Button
        data-mz-accent="success"
        className="w-[2.625rem] h-[2.625rem] p-0 shrink-0"
        onClick={onChange}
      >
        <Icon name="save" className="w-4" />
      </Button>
    </div>
  );
}
